import { DEFAULT_IDENTIFIER_LABELS } from './standardIdentifierTypes';

export const SETTINGS_HINT =
  'An Admin can set custom CSV identifier names in Organization → Settings.';

export function formatUnsupportedIdentifierMessage(configuredCustomNames: string[] = []): string {
  const customs = configuredCustomNames
    .map((n) => n.trim())
    .filter(Boolean);
  const configured = customs.length > 0 ? customs.join(', ') : 'none';
  return (
    `CSV must contain an identifier column (SKU, ASIN, GTIN, UPC, or a configured custom name). ` +
    `Accepted default identifiers: ${DEFAULT_IDENTIFIER_LABELS.join(', ')} ` +
    `(aliases such as Seller-SKU, EAN, barcode, and FNSKU also work). ` +
    `Configured custom identifiers: ${configured}. ${SETTINGS_HINT}`
  );
}
